import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import APP_CONST from "../../../shared/constants";
import { ViedocCheckboxElement } from "../../../../secure/elements/ViedocReactElements";
import StatusDialogueBox from "./StatusDialogueBox";

import * as actions from "../../../../store/actions/templateActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import * as zoneActions from "../../../../store/actions/zoneActions";
import Loader from "../../shared/Loader/Loader";

const Status = () => {
  const dispatch = useDispatch();
  const [lockUnlockStatusMsg, setLockUnlockStatusMsg] = useState("");
  const [isLockUnlockTmf, setIsLockUnlockTmf] = useState(false);
  const { t } = useTranslation();

  const {
    isEtmfLocked,
    lockedon,
    lockedby,
    fullDateTimePattern,
    dateLocale,
    lockStatus,
  } = useSelector((store) => store.template);

  const { userList, isReadOnlyAdmin, isZoneLoading } = useSelector(
    (store) => store.zone
  );
  const { isLockLoading } = useSelector((store) => store.template);

  const requestPayload = {
    reason: lockUnlockStatusMsg,
  };

  useEffect(() => {
    dispatch(zoneActions.fetchAllClientApis());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(actions.getLockStatus());
    isLockUnlockTmf && setIsLockUnlockTmf(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEtmfLocked]);

  const handleSubmit = () => {
    document.getElementById("StatusDialogueBox")?.hide();
    isLockUnlockTmf
      ? dispatch(actions.setETMFLock(requestPayload))
      : dispatch(actions.setETMFUnLock(requestPayload));
    setLockUnlockStatusMsg("");
  };

  const toggleLock = (e) => {
    document.getElementById("StatusDialogueBox")?.show();
    setIsLockUnlockTmf(e.srcElement.checked);
  };

  const renderToggleInfo = () => {
    return (
      <div className="flexgr-8 pl-15 w-45">
        <p className="f21 lh1_3">
          {isEtmfLocked
            ? t("ADMIN.TEXT_LOCKED") +
              " " +
              UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                lockedon,
                dateLocale
              ) +
              " " +
              t("TMF.TEXT_BY") +
              " " +
              UtilsHelper.findUserName(userList, lockedby)
            : !isEtmfLocked && lockStatus === "Enabled"
            ? t("ADMIN.TEXT_ENABLED")
            : t("ADMIN.TEXT_INSTANTIATED")}
        </p>
        <p className="f16 light-grey lh1_3">
          {isEtmfLocked
            ? t("ADMIN.TEXT_LOCKDESCRIPTION")
            : !isEtmfLocked && lockStatus === "Enabled"
            ? t("ADMIN.TEXT_ONLOCKSTATUSENABLED")
            : t("ADMIN.TEXT_ONLOCKSTATUSINSTANTIATED")}
        </p>
      </div>
    );
  };

  const renderToggle = () => {
    return (
      <div className="d-flex align-center pr-30 justfy-content-flex-end w-150">
        <p className="pr-10 f16">
          {isEtmfLocked ? t("ADMIN.TEXT_UNLOCKETMF") : t("ADMIN.TEXT_LOCKETMF")}
        </p>
        <ViedocCheckboxElement
          display-mode="toggle"
          checked={isEtmfLocked}
          onChange={(e) => toggleLock(e)}
        />
      </div>
    );
  };

  const renderToggleBlock = () => {
    return (
      <div className="d-flex pl-30 pt-30 status-clmn align-center">
        <div className={isEtmfLocked ? "lock-icon" : "unlock-icon"}>
          <viedoc-icon name={isEtmfLocked ? "lock" : "unlock"} />
        </div>

        {renderToggleInfo()}

        {!isReadOnlyAdmin && renderToggle()}
      </div>
    );
  };

  const renderStatusInfo = () => {
    return (
      <div className="d-flex align-center pl-30 pb-15 bb-1">
        <div className="status-bg">
          <viedoc-icon name="information"></viedoc-icon>
        </div>
        <p className="dark-grey pl-10 f14">
          {isEtmfLocked
            ? t("ADMIN.TEXT_ONUNLOCKMODE")
            : t("ADMIN.TEXT_ONLOCKMODE")}
        </p>
      </div>
    );
  };

  const renderStatusBodyStructure = () => {
    return (
      <section className={"d-flex flex-dir-col status"}>
        {!isReadOnlyAdmin && renderStatusInfo()}
        <header className="pl-30 pb-30 pt-30 bb-1">
          <h3>{t("ADMIN.ADMINTAB_STATUS")}</h3>
        </header>
        {renderToggleBlock()}
        <StatusDialogueBox
          lockUnlockStatusMsg={lockUnlockStatusMsg}
          setLockUnlockStatusMsg={setLockUnlockStatusMsg}
          handleSubmit={handleSubmit}
        />
      </section>
    );
  };

  return (
    <div className="Tmf-admin-status">
      {isLockLoading || isZoneLoading ? (
        <Loader />
      ) : (
        renderStatusBodyStructure()
      )}
    </div>
  );
};

export default Status;
